/*
 * @Author: vinnypeng
 * @Date: 2022-04-01 14:25:37
 * @Last Modified by: vinnypeng
 * @Last Modified time: 2022-04-19 11:19:03
 */
import { get } from '../lib/http';
import { GetServerSidePropsContext } from 'next';
import { HttpPrefix } from '../lib/wemeet-http-moudle';
interface StatusRes {
  code: number;
  message: string;
  nonce: string;
  data: Status;
}

export interface Status {
  is_show_activity_room: boolean | undefined;
  is_host: boolean | undefined;
  is_beta_user: boolean | undefined;
  gray_switch: Array<string> | undefined;
  has_payment_qualification: boolean | undefined;
  is_host_org_member: boolean | undefined;
}
export const defaultStatus = {
  is_show_activity_room: undefined,
  is_host: undefined,
  is_beta_user: undefined,
  gray_switch: undefined,
  has_payment_qualification: undefined,
  is_host_org_member: undefined,
};
export let nowStatus: Status = { ...defaultStatus };
export enum STATUS {
  UNREQUEST,
  LOADING,
  SUCCESS,
  ERROR,
}

let lastRequest: any = null;
let requestStatus = STATUS.UNREQUEST;

/**
 * 这个接口把多个入口接口合并查询了
 */

export const getEventsPlaceStatus = async (ctx?: GetServerSidePropsContext) => {
  console.log('event status 2');
  if (requestStatus === STATUS.LOADING) return lastRequest;
  requestStatus = STATUS.LOADING;
  const request = get<StatusRes>(HttpPrefix.WEMEET_TAPI, '/v2/activities/entry/batch', {}, ctx)
    .then((res) => {
      requestStatus = STATUS.SUCCESS;
      if (res?.code === 0) {
        nowStatus = { ...res?.data };
      }
      return res?.data;
    })
    .catch((error) => {
      console.log('getStatus Error', error);
      requestStatus = STATUS.ERROR;
      return defaultStatus;
    });
  lastRequest = request;
  return request;
};

export const getLocalStatus: any = async () => {
  let status = nowStatus;
  if (requestStatus !== STATUS.SUCCESS) {
    status = await getRemoteStatus();
  }
  return status;
};

export const getRemoteStatus = async () => {
  const data = await getEventsPlaceStatus();
  if (data?.is_host === undefined) {
    // 当前请求失败
    window?.nextAegis?.infoAll('【getRemoteStatus】 getEventsPlaceStatus error');
  }
  return data;
};
